import { InsurancePolicy } from "./InsurancePolicy/InsurancePolicy";
import { NoInsurance } from "./NoInsurance";
import { NoInsuranceModal } from "./NoInsurance/NoInsuranceModal";
import { ConnectPolicy } from "./ConnectPolicy";
import { useIsStateFarmPartitioned } from "../../app/Providers/AppContext";
import { usePolicies } from "./usePolicies";
import { InsuranceContextProvider } from "./InsuranceContext";
import { Fragment } from "react";

export const Insurance = () => {
  const policies = usePolicies();
  const isStateFarm = useIsStateFarmPartitioned();

  return policies.length === 0 ? (
    <>
      <NoInsurance isStateFarm={isStateFarm} />
      {/* Do not display NoInsuranceModal for State Farm partner login*/}
      {!isStateFarm && <NoInsuranceModal />}
    </>
  ) : (
    <InsuranceContextProvider policies={policies}>
      {policies.map((policy) => (
        <Fragment key={policy.policyNumber}>
          <InsurancePolicy policy={policy} />
        </Fragment>
      ))}
      {!isStateFarm && <ConnectPolicy />}
    </InsuranceContextProvider>
  );
};
